import { APICore } from "./apiCore";

const api = new APICore();
const baseUrl = "/web/corporates";

// Get all corporates
function getCorporatesApi(status?: string, page?: number, limit?: number) {
  const params: any = {};
  if (status) params.status = status;
  if (page) params.page = page;
  if (limit) params.limit = limit;
  return api.get(`${baseUrl}`, params);
}

// Add a new corporate
function addCorporateApi(params: { name: string; email: string; phone: string; address: string; is_active: boolean; code: any }) {
  return api.create(`${baseUrl}`, params);
}

// Update an existing corporate
function updateCorporateApi(params: { id: string; name: string; email: string; phone: string; address: string; is_active: boolean; code: any }) {
  return api.updatePatch(`${baseUrl}/${params.id}`, params);
}

// Delete a corporate
function deleteCorporateApi(params: { id: string }) {
  return api.delete(`${baseUrl}/${params.id}`);
}

export { getCorporatesApi, addCorporateApi, updateCorporateApi, deleteCorporateApi };
